module.exports = __webpack_public_path__ + "img/avatar-35.7d7b39c0.svg";